import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { COMPACT_QUERY } from "../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

export default function SaleSummarySkeleton() {
  return (
    <Paper>
      <Typography variant="body1" fontWeight={600} mb={2}>
        <Skeleton width={180} height={28} />
      </Typography>

      <Grid container spacing={3} sx={{ [compact]: { gap: 1.5 } }}>
        <Grid size={6}>
          <Box
            sx={{
              bgcolor: (theme) => theme.palette.primary.main + "0A",
              borderRadius: 3,
              p: 2,
              mb: 2,
              [compact]: { p: 1.5, mb: 1.5 },
            }}
          >
            <Skeleton width={80} />
            <Skeleton width={160} height={32} />
          </Box>

          <Box
            sx={{
              bgcolor: (theme) => theme.palette.primary.main + "0A",
              borderRadius: 3,
              p: 2,
              [compact]: { p: 1.5 },
            }}
          >
            <Skeleton width={100} />
            <Skeleton width={180} height={32} />
            <Box display="flex" alignItems="center" mt={1}>
              <Skeleton
                variant="rectangular"
                width={60}
                height={28}
                sx={{ borderRadius: 8, mr: 1 }}
              />
              <Skeleton width={100} />
            </Box>
          </Box>
        </Grid>

        <Grid size={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Skeleton
              variant="circular"
              width={200}
              height={200}
              sx={{ [compact]: { width: 166, height: 166 } }}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
